import { prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialPressRelease
 */

/**
 * @typedef {DocumentSchema} FinancialPressReleaseSchema
 */

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialPressRelease} data
 * @return {FinancialPressReleaseSchema}
 */
const processFinancialPressRelease = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_PRESS_RELEASE,
    type: DocumentType.FINANCIAL_PRESS_RELEASE,
    ...processFinancialFooter(data),
    filters: {
      [FILTER.MENU]: MENU.STATISTICS,
    },
  });

/**
 * Normalizr schema representing a financial press release page
 */
export const FinancialPressRelease = deprecatedPageEntity(
  DocumentType.FINANCIAL_PRESS_RELEASE,
  {
    processStrategy: (entity) =>
      processFinancialPressRelease(prop('data', entity)),
  }
);
